import CryptoJS from "crypto-js";

export const encryptPassword = (password) => {
    const secretKey =
        process.env.REACT_APP_AUTH_SHARED_SECRET ||
        (typeof window !== 'undefined' ? window.__AUTH_SHARED_SECRET__ : '');

    if (!secretKey) {
        throw new Error('AUTH_SHARED_SECRET no configurado (Auth:SharedSecret o REACT_APP_AUTH_SHARED_SECRET).');
    }

    // Asegurarse de que la clave tenga exactamente 16 bytes (128 bits)
    const key = CryptoJS.enc.Utf8.parse(secretKey.slice(0, 16)); // Recorta a 16 caracteres si es necesario

    const encrypted = CryptoJS.AES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,    // Modo ECB
        padding: CryptoJS.pad.Pkcs7 // Padding PKCS7
    }).toString();

    return encrypted;
};